// v2.7 US-3.4: text for the "?" help tips (components/HelpTip.js).
// One entry per tip: { title?, body }. Plain "you" voice, one idea, no
// exclamation marks, 45 words at most (helpText.test.js enforces it). Each
// entry names the code it describes, so a feature change can find its tip.
// Facts verified against the code on 2026-09-29.
const HELP = {
  // ---- Coach ------------------------------------------------------------
  // CoachRegister program type; utils/programType.js; Settings → Program Type
  'register.programType': {
    title: 'Program type',
    body: 'Paid tracks monthly fees and shows parents how to pay you. Free and Free — YMCA have no payment screens at all. You can change this later in Settings.',
  },
  // Settings monthly fee; per-player override in Families → Edit Player
  'settings.monthlyFee': {
    title: 'Monthly fee',
    body: 'Each active player is charged this every month. To give one player a different fee or waive it, edit the player on the Families page.',
  },
  // Settings payment due day; server/lib/reminders.js payment reminders
  'settings.paymentDueDay': {
    title: 'Payment due day',
    body: 'Monthly charges are added either way. This day only sets when families who still owe get their one reminder for the month, at 9 am by email, and by text if they turned texts on.',
  },
  // components/SeasonManager.js rollover
  'season.newSeason': {
    title: 'New season',
    body: 'Nothing is deleted. This season’s schedule, results and attendance move to the archive, which stays readable on the Schedule page. The record starts at zero, and your roster and families carry over.',
  },
  // Schedule add form "Repeats weekly until"; series scope this / future
  'schedule.repeatsWeekly': {
    title: 'Weekly series',
    body: 'Adds the same event every week up to this date. Later, when you edit, cancel or postpone one, you choose “This one only” or “This and all later weeks”.',
  },
  // Schedule event actions: Postpone / Cancel / Delete (handleDeleteGame confirm)
  'schedule.eventActions': {
    title: 'Postpone, Cancel or Delete',
    body: 'Postpone and Cancel keep the event, can tell families, and can be undone with “Put it back on”. Delete removes it for good and tells no one.',
  },
  // components/SignupsPanel.js coach view, addTemplate
  'signups.coach': {
    title: 'Sign-ups',
    body: '“Add the usual three” adds Snacks (2 people), Scorekeeper and Bench parent. Families tap “I’ll do it” to claim a slot, and can offer or ask for a ride below.',
  },
  // components/CalendarSubscribe.js; server/lib/ical.js X-PUBLISHED-TTL PT1H
  'calendar.link': {
    title: 'Calendar link',
    body: 'Calendar apps check the link about once an hour, and Google Calendar can take longer. If the link was shared by mistake, “New link” stops the old one from working.',
  },
  // Families → Edit Player fee override (paid programs)
  'families.feeOverride': {
    title: 'Player fee',
    body: 'Leave it blank to use the program fee, or enter 0 to waive it. The new amount applies from this month on. Adding a reason is optional.',
  },
  // LedgerPayments month summary; server/lib/ledger.js
  'ledger.totals': {
    title: 'Month summary',
    body: 'Charged is this month’s fees plus one-off charges, minus credits. Collected is what you recorded as paid. Outstanding is the difference. All-time owed covers every month so far.',
  },
  // LedgerPayments "+ Charge or credit" dialog
  'ledger.chargeOrCredit': {
    title: 'Charge or credit',
    body: 'For one-off items like a tournament fee, or a credit that lowers what a family owes. It shows on that family’s Payments page and statement. You can add these for the current month only.',
  },
  // LedgerPayments "Record payment" dialog; ParentPaymentsLedger line items show method + note
  'ledger.recordPayment': {
    title: 'Money received',
    body: 'Record money a family paid you directly, in any amount, for the whole family or one child. The family sees the method and the note on their Payments page, so keep notes friendly.',
  },
  // components/WaiverEditor.js versions
  'waiver.versions': {
    title: 'Waiver versions',
    body: 'Changing the title or text publishes a new version, and families sign again. Ticking Required on or off doesn’t. Required flags unsigned players and emails their families once when you publish, then every Monday; it doesn’t block anyone from joining.',
  },

  // ---- Coach, P2 (US-3.4d; facts verified 2026-10-01) ---------------------
  // Settings Time Zone; server/lib/reminders.js (17:00 / 09:00 program time);
  // gamesController computeStartsAt stores starts_at at save time (not
  // recomputed when the zone changes; calendarController feeds starts_at)
  'settings.timezone': {
    title: 'Time zone',
    body: 'Event times you enter are read in this zone for calendar links and reminders: game and practice reminders at 5 pm the day before, payment and waiver reminders at 9 am. Pick it before adding events, as saved events keep their calendar times.',
  },
  // Settings Team Chat; chatController post() refuses everyone while chat_enabled is false
  'settings.teamChat': {
    title: 'Team chat',
    body: 'When it’s off, nobody can post, you included, but everyone can still read past messages. Turn it back on any time. Each family can also turn chat notifications off for themselves on the Team Chat page.',
  },
  // Settings Albums switch; mediaController createUpload (uploads_off), deleteItem (own only)
  'settings.parentUploads': {
    title: 'Parent uploads',
    body: 'When it’s on, families can add photos and videos to the albums and delete their own. Turning it off only stops new uploads; everything already added stays.',
  },
  // Settings Notifications rsvpChase; reminders.js runRsvpChases (72 h / 24 h
  // stages, any RSVP counts, skips cancelled/postponed, family toggle rsvpChase)
  'settings.rsvpChase': {
    title: 'RSVP follow-ups',
    body: 'Families who haven’t answered for a player get a follow-up about 3 days and again about 1 day before, by email, push, and text if they turned texts on. Answering stops them. Families can turn these off in their profile.',
  },
  // components/VenuesManager.js; venuesController venueFields copies name +
  // address into games.location at save; update/delete never touch saved events
  'venues.saved': {
    title: 'Saved venues',
    body: 'Picking a saved venue copies its name and address into the event, so families get directions and calendar apps get the address. Editing or removing a venue later doesn’t change events you already saved.',
  },
  // components/ProgramSwitcher.js "New program" dialog; requireActiveSubscription is per coach
  'orgs.newProgram': {
    title: 'Several programs',
    body: 'Each program has its own roster, schedule, families, messages and payments, under one login and one subscription. Once you have two, switch with the menu above “+ New program”. Families join each program with its own team code.',
  },
  // components/ScorePanel.js share link; scoreboardController public view
  // (no login, top 5 scorers as "Alex J."), token rotate
  'score.shareLink': {
    title: 'Public score link',
    body: 'Anyone with this link can follow the score live without logging in. The page lists the top scorers by first name and last initial. If the link spreads too far, “New link” stops the old one.',
  },
  // components/AttendanceModal.js pre-fill from RSVPs; attendance routes are coach-only
  'attendance.sheet': {
    title: 'Who came',
    body: 'The sheet starts from RSVPs: Going is marked Present and Not going Absent, until you save your own marks. Families don’t see attendance in the app. Medical notes and emergency contacts show here for game day.',
  },
  // TeamRoster "Medical Alerts" stat; players roster route is coach-only;
  // parents edit their own child (EditChildModal on My Children)
  'roster.medical': {
    title: 'Medical alerts',
    body: 'Counts players with medical notes or allergies on file. Only coaches and the child’s own family can see the notes. Families add and update them on My Children, and they also show on your attendance sheet.',
  },
  // Messages "Message Type"; messagesController wantsCoachEmail (emergency
  // ignores the family's coachMessages toggle); ParentMessages label "Important"
  'messages.type': {
    title: 'Message type',
    body: 'The type labels your message for families, for example “Practice Update”. Emergency / Cancellation shows as Important and is emailed even to families who turned coach message emails off, so keep it for urgent news.',
  },
  // components/DataRights.js coach view; exportData collectCoachData (active
  // program only, album files not included); deleteAccount closes every owned program
  'dataRights.coach': {
    title: 'About your data',
    body: 'The export covers only the program you have open, so switch programs to export another. Album photos are listed but not included. Deleting closes every program you own, and you can’t undo it in the app.',
  },

  // ---- Parent -----------------------------------------------------------
  // ParentRegister lookup; /parent/register?code= pre-fills
  'parent.register.teamCode': {
    title: 'Team code',
    body: 'Your coach can give you the team code, or you can enter the coach’s phone number instead. If your coach sent you a sign-up link, the code is already filled in.',
  },
  // ParentSchedule "Who's coming?" RSVP
  'parent.schedule.rsvp': {
    title: 'Who’s coming?',
    body: 'Tell the coach for each child: Going, Maybe or Not going. You can change it any time until the event is over or cancelled.',
  },
  // ParentPaymentsLedger total due
  'parent.payments.balance': {
    title: 'Total due',
    body: 'What your family owes this month for all your children together. Pay your coach with one of the ways below. Your coach records the payment here, and then this total updates.',
  },
  // ParentProfile text messages; server/controllers/smsController.js keywords
  'parent.profile.texts': {
    title: 'Text messages',
    body: 'Texts cover game reminders, schedule changes, coach messages and payment reminders. Reply STOP to any text to turn them off, and START to turn them back on.',
  },
  // R-6: same row on a free program, which sends no payment reminders
  'parent.profile.texts.free': {
    title: 'Text messages',
    body: 'Texts cover game reminders, schedule changes and coach messages. Reply STOP to any text to turn them off, and START to turn them back on.',
  },
  // ParentWaiver typed signature; waiversController stores name, time, IP
  'parent.waiver.signature': {
    title: 'Typed signature',
    body: 'Typing your name counts as your signature, once for each child. No copy is emailed, but you can see “Signed by” with the date on this page any time.',
  },

  // ---- Parent, P2 (US-3.4d; facts verified 2026-10-01) --------------------
  // components/SignupsPanel.js parent view; signupsController (names only,
  // never email/phone; no notification on claim or seat request)
  'parent.signups': {
    title: 'Helping out',
    body: 'Tap “I’ll do it” to take a volunteer slot. You can offer spare seats in your car or ask for a seat in someone else’s. Families see only each other’s names and nobody is notified, so confirm pick-up with the driver.',
  },
  // ParentProfile Notification Preferences; reminders.js toggles (all
  // channels), messagesController coachMessages = email copies only, emergency
  // always emailed; lib/notify.js schedule-change notices ignore the toggles
  'parent.profile.notifications': {
    title: 'Notification switches',
    body: 'Each switch turns one kind of automatic reminder on or off, by email, text and push. Coach Messages only controls email copies. Messages always appear in Messages, and schedule changes and Important news reach you either way.',
  },
  // components/InstallPrompt.js (14-day snooze); manifest display standalone
  'install.homeScreen': {
    title: 'Home screen app',
    body: 'Adds a HoopHero icon that opens full screen, without the browser bar. On iPhone, notifications only work once HoopHero is on your home screen. “Not now” hides this card for 14 days.',
  },
};

export default HELP;
